<script lang="ts">
    import {ignoreUnusedProperties} from 'shared/utils/custom-utils';

    export let option: any;
    export let usedAsLabel = false;

    ignoreUnusedProperties(usedAsLabel);
</script>

{option.code} = {option.description}